function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "menu-idp-review",
  "data-name": "Group 14949",
  transform: "translate(-2 -1.81)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3520",
  "data-name": "Path 3520",
  d: "M11.568,2.789H7.8c-3.1,0-5.046,2.2-5.046,5.3V16.48c0,3.109,1.936,5.3,5.046,5.3h8.9c3.112,0,5.047-2.2,5.047-5.3V12.417",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3521",
  "data-name": "Path 3521",
  d: "M8.834,10.992l7.538-7.538a2.406,2.406,0,0,1,3.4,0L21,4.682a2.4,2.4,0,0,1,0,3.4l-7.574,7.574a2.19,2.19,0,0,1-1.548.642H8.1l.095-3.813A2.189,2.189,0,0,1,8.834,10.992Z",
  transform: "translate(0.046)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3522",
  "data-name": "Path 3522",
  d: "M15.165,4.6l4.606,4.606",
  transform: "translate(0.108 0.016)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

function SvgMenuIdpReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.725,
    viewBox: "0 0 20.5 20.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIdpReview);
export default __webpack_public_path__ + "static/media/menu-idp-review.4bd75237.svg";
export { ForwardRef as ReactComponent };